import Vue from 'vue';

const state = {
    team: [],
    isDownloadingTeam: false,

    agents: [],
    isDownloadingAgents: false,

    communityAgents: null,
    isDownloadingCommunityAgents: false,
    isConnectingToCommunityAgents: false,

    customers: [],
    teamLabels: {},
    agentsLabels: {}, // not used?
    customersLabels: {},
    roles: [],
    contactTypes: [],
    selectedPerson: null,
    clonedAgent: {},
    newAgentSetup: {
        email: '',
        brandName: '',
        place: '',
    },
    isLoadingAssociatedAgent: false,
    peopleInviteStatus: [
        {
            id:"0",
            label:"OFFLINE",
            colorClass:"border-medium bg-medium",
            actionLabel: 'Invite to join Pluralo',
            actionClass:"blue",
        },
        {
            id:"5",
            label:"AVAILABLE",
            colorClass:"bg-lightest border-medium color-1",
            actionLabel: 'Connect',
            actionClass:"green",
        },
        {
            id:"10",
            label:"PENDING",
            colorClass:"bg-lightest border-medium dark"
        },
        {
            id:"15",
            label:"CONNECTED",
            colorClass:"bg-lightest border-medium color-3"
        },
        {
            id:"20",
            label:"Connection Refused",
            colorClass:"bg-lightest border-medium color-6"
        },
        {
            id:"25",
            label:"Protocol Canceled",
            colorClass:"bg-lightest border-medium color-6"
        },
    ],
    protocolStatus: [
        {
            id:0,
            label: "CONNECTED", //active
            colorClass:"bg-lightest border-medium color-3"
        },
        {
            id:1,
            label: "CONNECTED", //active
            colorClass:"bg-lightest border-medium color-3"
        },
        {
            id:5,
            label: "BLOCKED",
            colorClass:"bg-lightest border-dark dark"
        },
        {
            id:10,
            colorClass: "REMOVED"
        },
    ],
    depositOptions: [
        {
            "id":0,
            "description":"Fixed amount (total)"
        },
        {
            "id":1,
            "description":"Percentage"
        },
        {
            "id":2,
            "description":"Percentage is equal to Commission"
        }
    ],
    requirePaymentOptions: [
        {"id":1,"description":"Require payment of full amount"},
        {"id":2,"description":"Require payment of deposit"}
    ],
    isGettingAgentInfo: false,
    selectedUnknownAgentId: null,
};

const getters = {
    getTeam: (state) => state.team,
    getTeamLabels: (state) => state.teamLabels,
    getAgents: (state) => state.agents,
    getAgentsLabels: (state) => state.agentsLabels,
    getCustomers: (state) => state.customers,
    getCustomersLabels: (state) => state.customersLabels,
    getSelectedPerson: (state) => state.selectedPerson,
    getRoles: (state) => state.roles,
    getContactTypes: (state) => state.contactTypes,
    getClonedAgent: (state) => state.clonedAgent,
    getNewAgentSetup: (state) => state.newAgentSetup,
    getIsLoadingAssociatedAgent: (state) => state.isLoadingAssociatedAgent,
    getInviteStatusTypes: (state) => state.peopleInviteStatus,
    getProtocolStatusTypes: (state) => state.protocolStatus,

    filterAgentsByType: (state) => type => {
        return state.agents.filter(agent => agent.type === type);
    },

    getAgentById: (state) => id => {
        return state.agents.find(agent => agent.id === id);
    },

    getIsGettingAgentInfo: (state) => state.isGettingAgentInfo,
    getDepositOptions: (state) => state.depositOptions,
    getRequirePaymentOptions: (state) => state.requirePaymentOptions,
    getSelectedUnknownAgentId: (state) => state.selectedUnknownAgentId,

    // Community Agents
    getCommunityAgents: (state) => {
        if(!state.communityAgents){
            return []
        }


        state.communityAgents.map(communityAgent => {
            state.agents.map(myAgent => {
                if(communityAgent.email == myAgent.email){
                    // communityAgent.test = 'Hey'
                    communityAgent.inviteStatus = myAgent.inviteStatus
                    communityAgent.protocolStatus = myAgent.protocolStatus
                }
            })
        })
        return state.communityAgents
    },
    getIsConnectingToCommunityAgents: (state) => state.isConnectingToCommunityAgents,
    getIsDownloadingCommunityAgents: (state) => state.isDownloadingCommunityAgents,
};

const actions = {

    initPeople: ({ commit }, data) => {
        var roles = [
            { id: 1, label: 'Agent' },
            { id: 2, label: 'Tour Operator' },
            { id: 3, label: 'Ticket Shop' },
            { id: 4, label: 'Online Platform' },
            { id: 5, label: 'Agency' },
        ];

        var contactTypes = [
            { id: 1, label: 'Geral' },
            { id: 2, label: 'Reservations' },
            { id: 3, label: 'Other' },
        ];

        var teamLabels = {
            name: 'Name',
            role: 'Role',
            phone: 'Phone',
            email: 'Email',
            address: '',
        };

        var team = [
            {
                id: 1,
                name: 'Carla Marques',
                role: 'seller',
                phone: '+351 123 234 345',
                email: 'carlamarques@pluralo.com',
            },
             {
                id: 2,
                name: 'Lara Antunes',
                role: 'seller',
                phone: '+351 123 234 345',
                email: 'laraantunes@pluralo.com',
            },
             {
                id: 3,
                name: 'João Semedo',
                role: 'crew',
                phone: '+351 123 234 345',
                email: 'joaosemedo@pluralo.com',
            },
             {
                id: 4,
                name: 'Marco Fabrício',
                role: 'crew',
                phone: ' ',
                email: 'marcofabricio@pluralo.com',
            },
             {
                id: 5,
                name: 'Catarino',
                role: 'Management',
                phone: '+351 123 234 345',
                email: 'catarino@pluralo.com',
            },
             {
                id: 6,
                name: 'Helena',
                role: 'Management',
                phone: ' ',
                email: 'helena@pluralo.com',
            },
             {
                id: 7,
                name: 'Antonio Silva',
                role: 'Tour Guide',
                phone: ' ',
                email: 'antoniosilva@pluralo.com',
            },
             {
                id: 8,
                name: 'Fábio Quaresma',
                role: 'Tour Guide',
                phone: ' ',
                email: 'fabioquaresma@pluralo.com',
            },

        ];

        var customersLabels = {
            name: 'Name',
            from: 'From',
            lastreservation: 'Last Reservation',
            total: 'Total Sales',
        };

        var customers = [
            {
                id: 1,
                name: 'Frances Bishop',
                from: 'UK',
                lastreservation: '14-05-2017',
                total: '120,00€',
            },
            {
                id: 2,
                name: 'Arthur Fisher',
                from: 'UK',
                lastreservation: '14-05-2017',
                total: '230,00€',
            },
             {
                id: 3,
                name: 'Amy Silva',
                from: 'Ireland',
                lastreservation: '14-05-2017',
                total: '70,00€',
            },
             {
                id: 4,
                name: 'Harold Douglas',
                from: 'UK',
                lastreservation: '13-05-2017',
                total: '1000,00€',
            },
              {
                id: 5,
                name: 'Jean Soir',
                from: 'France',
                lastreservation: '13-05-2017',
                total: '150,00€',
            },
            {
                id: 6,
                name: 'Emma Austin',
                from: 'UK',
                lastreservation: '13-05-2017',
                total: '50,00€',
            },
            {
                id: 7,
                name: 'Larry Salazar',
                from: 'USA',
                lastreservation: '13-05-2017',
                total: '120,00€',
            },
            {
                id: 8,
                name: 'Marilyn Delgado',
                from: 'Mexico',
                lastreservation: '13-05-2017',
                total: '120,00€',
            },
            {
                id: 9,
                name: 'João Spencer',
                from: 'USA',
                lastreservation: '13-05-2017',
                total: '80,00€',
            },
            {
                id: 10,
                name: 'Scott Carlson',
                from: 'UK',
                lastreservation: '13-05-2017',
                total: '100,00€',
            },
            {
                id: 11,
                name: 'Antonio Freitas',
                from: 'PT',
                lastreservation: '13-05-2017',
                total: '30,00€',
            },
            {
                id: 12,
                name: 'Salvador Martins',
                from: 'PT',
                lastreservation: '13-05-2017',
                total: '50,00€',
            },
            {
                id: 13,
                name: 'João Matos',
                from: 'PT',
                lastreservation: '13-05-2017',
                total: '80,00€',
            },
            {
                id: 14,
                name: 'Susy Zukenger',
                from: 'Germany',
                lastreservation: '12-05-2017',
                total: '230,00€',
            },
            {
                id: 15,
                name: 'Ana Mendes',
                from: 'PT',
                lastreservation: '12-05-2017',
                total: '60,00€',
            },
        ];

        commit('INIT_CONTACT_TYPES', contactTypes);
        commit('INIT_ROLES', roles);
        // commit('INIT_TEAM', { team: team, labels: teamLabels });
        // commit('INIT_CUSTOMERS', { customers: customers, labels: customersLabels });
    },

    async initAgents ({ commit, dispatch, rootState }) {
        try {
            state.isLoadingAssociatedAgent = true
            let response = await axios.get('/api/people/GetAssociatedAgents', { params: { supplierId: rootState.user.account.supplierId }});
            state.isLoadingAssociatedAgent = false

            if (response && response.status === 200 && response.data) {
                commit('INIT_AGENTS', {
                    agents: response.data,
                    labels: {
                        image: '',
                        name: 'Name',
                        phone: 'Phone',
                        email: 'Email',
                        status: 'Status',
                    }
                });

                return true;
            }

            return false;
        }
        catch (error) {
            //Vue.toasted.error(error);
        }
    },

    addAgent: ({ state, commit, dispatch, rootState }, options) => {

        options = options? options : {}
        let data = {
            supplierId: rootState.user.account.supplierId,
            agent: state.clonedAgent,
            notificationId: state.clonedAgent.notificationId? state.clonedAgent.notificationId : null,
            sendInvite: state.clonedAgent.saveAndSend
        };

        dispatch('startFullScreenLoading');

        return axios.post('/api/people/CreateAgent', data).then((response) => {
            dispatch('stopFullScreenLoading');
            if (response && response.status === 200) {
                commit('UPDATE_LIST', { table: 'agents', object: response.data.data });
                dispatch('clearSelectedPerson');
                dispatch('closeModal');
                if(data.notificationId){
                    dispatch('changeNotificationLocally', {
                        notificationId: data.notificationId,
                        dataToChange: {
                            typeStatus: 402
                        }
                    })
                }

                if(data.notificationId){
                    Vue.toasted.success('Your commissions agreement is on the way');
                } else {
                    Vue.toasted.success('Agent created successfully!');
                }

                Vue.router.push({ name: 'people' });
            }
        })
        .catch(function(error) {
            dispatch('stopFullScreenLoading');
            //Vue.toasted.error(error);
        });
    },

    inviteAgent:({state, commit, rootState}, payload) => {

        if(payload.agentId){
            commit('SET_AGENT_LOADING', payload.agentId) // adds flag "isLoading" to agent, so we can show a loader
        }

        Vue.toasted.info('Sending invite to agent');
        return axios.post('/api/Supplier/SendInviteToAgent', {
            supplierId: rootState.user.account.supplierId,
            agent: payload.agent
        }).then(response => {
            if (response && response.status === 200) {
                Vue.toasted.success('Invite sent successfully!');
            }
            return response
        }).catch(err => {
            return err
        })
    },

    connectToAgent:({state, commit, rootState}, payload) => {
        commit('SET_AGENT_LOADING', payload.agentId) // adds flag "isLoading" to agent, so we can show a loader
        Vue.toasted.info('Sending connect request');
        return axios.post('/api/Supplier/SendConnectToAgent', {
            supplierId: rootState.user.account.supplierId,
            agent: payload.agent
        }).then(response => {
            if (response && response.status === 200) {
                Vue.toasted.success('Connection request sent successfully!');
            }
            return response
        }).catch(err => {
            return err
        })
    },

    disconnectAgent: ({state, commit, rootState}, payload) => {
        commit('SET_AGENT_LOADING', payload.agentId) // adds flag "isLoading" to agent, so we can show a loader
        return axios.get('/api/Community/SupplierRemoveAgentProtocol', {
            params: {
                supplierId: rootState.user.account.supplierId,
                agentId: payload.agentId
            }
        }).then(response => {
            if (response && response.status === 200) {
                Vue.toasted.success('Agent disconnectect successfully!');
            }
            return response
        }).catch(err => {
            return err
        })

    },

    suspendAgent: ({state, commit, rootState}, payload) => {
        commit('SET_AGENT_LOADING', payload.agentId) // adds flag "isLoading" to agent, so we can show a loader
        return axios.get('/api/Community/SupplierSuspendAgentProtocol', {
            params: {
                supplierId: rootState.user.account.supplierId,
                agentId: payload.agentId
            }
        }).then(response => {
            if (response && response.status === 200) {
                Vue.toasted.success('Agent suspended successfully!');
            }
            return response
        }).catch(err => {
            return err
        })

    },

    unsuspendAgent: ({state, commit, rootState}, payload) => {
        commit('SET_AGENT_LOADING', payload.agentId) // adds flag "isLoading" to agent, so we can show a loader
        return axios.get('/api/Community/SupplierActiveAgentProtocol', {
            params: {
                supplierId: rootState.user.account.supplierId,
                agentId: payload.agentId
            }
        }).then(response => {
            if (response && response.status === 200) {
                Vue.toasted.success('Agent unblocked successfully!');
            }
            return response
        }).catch(err => {
            return err
        })

    },

    updateAgent: ({ state, commit, dispatch, rootState }, payload) => {
        let data = {
            supplierId: rootState.user.account.supplierId,
            agent: payload.agent,
            notificationId: payload.agent.notificationId? payload.agent.notificationId : null,
            sendInvite: payload.sendInvite? payload.sendInvite : null,
        };
        dispatch('startFullScreenLoading');

        axios.post('/api/people/EditAgent', data).then((response) => {
            dispatch('stopFullScreenLoading');
            if (response && response.status === 200 && response.data) {

                commit('UPDATE_LIST', { table: 'agents', object: response.data.data });
                dispatch('closeModal');
                dispatch('clearSelectedPerson');

                dispatch('initAgents'); //reloads agent list
                if(payload.agent.notificationId){
                    Vue.toasted.success('Your commissions agreement is on the way');
                } else {
                    Vue.toasted.success('Agent updated successfully!');
                }

                Vue.router.push({ name: 'people' });
            }
        })
        .catch(function (error) {
            dispatch('stopFullScreenLoading');
            //Vue.toasted.error(error);
        });
    },

    updateClonedAgent: ({ commit }, fields) => {
        commit('UPDATE_CLONED_AGENT', fields);
    },

    clearClonedAgent: ({ commit }, fields) => {
        commit('CLEAR_CLONED_AGENT');
    },

    addAgentContact: ({ commit }, contact) => {
        commit('ADD_CONTACT', { agent: getters.getSelectedPerson, contact: contact });
    },

    resetAgent: ({ commit }) => {
        commit('RESET_AGENT');
    },

    setSelectedPerson: ({ commit }, data) => {
        commit('SET_SELECTED_PERSON', data);
    },

    clearSelectedPerson: ({ commit, dispatch }) => {
        dispatch('closeModal');
        commit('CLEAR_SELECTED_PERSON');
    },

    resetNewAgentSetup: ({ commit }) => {
        commit('RESET_NEW_AGENT_SETUP');
    },

    updateNewAgentSetup: ({ commit }, fields) => {
        commit('UPDATE_NEW_AGENT_SETUP', fields);
    },

    associateAgent: ({commit, rootState}, payload) => {
        axios.post(axios.defaults.baseURL+'api/people/CreateAgentProtocol',{
            supplierId: rootState.user.account.supplierId,
            agent: payload.agent
        }).then((response) => {
            if (response && response.status === 200) {
                Vue.toasted.success(response.data.message);
                //if succeeds adds agent to list, one less request
                commit('ADD_PERSON', { table: 'agents', person: payload.agent });
            }
        }).catch((err) => {
            console.log(err);
        })
    },

    // ---------------

    downloadAgents: ({ commit, rootState }) => {
        state.isDownloadingAgents = true
        return axios.get('/api/people/GetAssociatedAgents', {
            params: {
                supplierId: rootState.user.account.supplierId
            }
        }).then(response => {
            state.isDownloadingAgents = false
            if(response.status == 200){

                commit('UPDATE_AGENTS', response.data)
            }
        }).catch(err => {
            state.isDownloadingAgents = false
        })
    },

    downloadTeam: ({ commit, rootState }) => {
        state.isDownloadingTeam = true
        return axios.get('/api/supplier/memberList', {
            params: {
                supplierId: rootState.user.account.supplierId
            }
        }).then(response => {
            state.isDownloadingTeam = false
            if(response.status == 200){

                // everytime we download "team" from API we look for the current user and update his sales channel
                let foundMe = response.data.filter(responseMenber => {
                    return responseMenber.id == rootState.user.account.id
                })[0]

                if(foundMe){
                    rootState.user.account.salesChannel = foundMe.salesChannel
                }
                // ****

                commit('UPDATE_TEAM', response.data)
            }
        }).catch(err => {
            state.isDownloadingTeam = false
        })
    },

    getAgentInfo: ({state, rootState}, payload) => {
        state.isGettingAgentInfo = true
        return axios.get('/api/Community/GetAgentDetails', {
            params: {
                supplierId: rootState.user.account.supplierId,
                agentId: payload.agentId
            }
        }).then(response => {
            state.isGettingAgentInfo = false
            return response
        }).catch(err => {
            state.isGettingAgentInfo = false
            return err
        })
    },

    openUnkownAgent: ({state, dispatch}, payload) => {
        dispatch('openModal', 'agentUnknownView')
        state.selectedUnknownAgentId = payload.agentId
    },

    downloadCommunityAgents: ({commit, state, rootState}) => {
        state.isDownloadingCommunityAgents = true
        axios.get('/api/Community/GetAgentsToSupplier', {
            params: {
                supplierId: rootState.user.account.supplierId,
            }
        }).then(response => {
            state.isDownloadingCommunityAgents = false
            if(response.status == 200){
                commit('UPDATE_COMMUNITY_AGENTS', response.data)
            }
            return response
        }).catch(err =>{
            state.isDownloadingCommunityAgents = false
            return err
        })
    },

    connectCommunityAgent: ({state, commit, rootState}, payload) => {
        state.isConnectingToCommunityAgents = true
        return axios.post('/api/Community/SendConnectDefaultToAgent',{
            supplierId: rootState.user.account.supplierId,
            agent: payload.agent
        }).then(response => {
            state.isConnectingToCommunityAgents = false
            return response
        }).catch(err => {
            state.isConnectingToCommunityAgents = false
            return err
        })
    },

}

const mutations = {
    INIT_TEAM: (state, data) => {
        state.team = data.team;
        state.teamLabels = data.labels;
    },

    INIT_AGENTS: (state, data) => {
        state.agents = data.agents;
        state.agentsLabels = data.labels;
    },

    // INIT_CUSTOMERS: (state, data) => {
    //     state.customers = data.customers;
    //     state.customersLabels = data.labels;
    // },

    // Adds a new contact entry to the selected agent

    ADD_CONTACT: (state, data) => {
        var agent = data.agent;

        if (agent.contacts === undefined) {
            agent.contacts = [];
        }

        agent.contacts.push(data.contact);
    },

    ADD_PERSON: (state, data) => {
        state[data.table].push(data.person);
    },

    RESET_AGENT: (state) => {
        var agent = {
            name: null,
            code: null,
            //channel: null,
            email: null,
            phone: null,
            role: null,
            image: '',
            website: null,
            facebook: null,
            twitter: null,
            permissions: {
                book: null
            },
            company: {
                name: null,
                vat: null,
                address: null,
                zip: null,
                place: null
            },
            transportation: {
                pickup: null,
                area: null
            },
            contacts: [
                { type: null, email: null, phone: null },
            ]
        }

        state.selectedPerson = agent;
    },

    SET_SELECTED_PERSON: (state, payload) => {
        state.selectedPerson = payload;

    },

    INIT_ROLES: (state, roles) => {
        state.roles = roles;
    },

    INIT_CONTACT_TYPES: (state, contactTypes) => {
        state.contactTypes = contactTypes;
    },

    // Updates a set of fields in an object

    UPDATE_PERSON: (state, data) => {
        if (state[data.object] === undefined || !state[data.object]) {
            state[data.object] = {};
        }

        Object.keys(data.fields).forEach((key) => {
            Vue.set(state[data.object], key, data.fields[key]);
        });
    },

    // Updates the list of objects with a newly created/updated one

    UPDATE_LIST: (state, data) => {
        let target = state[data.table].find(item => item.id === data.object.id);

        // Update or create

        if (target) {
            Object.keys(data.object).forEach((key) => {
                Vue.set(target, key, data.object[key]);
            });
        }
        else {
            state[data.table].push(data.object);
        }
    },

    CLEAR_SELECTED_PERSON: (state) => {
        state.selectedPerson = null;
    },

    UPDATE_CLONED_AGENT: (state, fields) => {
        Object.keys(fields).forEach((key) => {
            Vue.set(state.clonedAgent, key, fields[key]);
        });
    },

    CLEAR_CLONED_AGENT: (state) => {
        // Vue.set(state.clonedAgent, null);
        state.clonedAgent = {}
    },

    RESET_NEW_AGENT_SETUP: (state) => {
        state.newAgentSetup = {
            saveAndSend: true,
            name: null,
            brandName: null,
            contactFinancialEmail: '',
            contactFinancialPhone: '',
            contactSalesEmail: '',
            contactSalesPhone: '',
            contactOthersEmail: '',
            contactOthersPhone: '',
            note: '',
            address: '',
            country: null,
            vat: '',
            zip: '',
            place: '',
            transportation: {},
            contacts: [],
            email: '',
            phone: '',
            role: null,
            payment: 1,
            deposit: null,
            imageLogo: null,
            imageLogoBase64: null,
            locationMain: null,
            agentSize: null,
            salesChannel: null,
            bookPermission: false,
            DepositCurrency: "€",
            SalesStore: false,
            SalesWebsite: false,
            SalesHotel: false,
            currency: "€",
            timezone: null, //qual é o formato?
            slogan: "",
            website: "",
            facebook: "",
            twitter: "",
            pluraloUrl: "",
            isWorkflowAllowedToSendEmails: true,
        }
    },

    UPDATE_NEW_AGENT_SETUP: (state, fields) => {
        Object.keys(fields).forEach((key) => {
            Vue.set(state.newAgentSetup, key, fields[key]);
        });
    },

    // ---------------
    UPDATE_AGENTS: (state, payload) => {
        //add isLoading = false to all agents, its usefull in the future
        payload.map(agent => {
            agent.isLoading = false
        })

        state.agents = payload
    },

    PUSH_AGENT_TO_AGENTS: (state, agent) => {
        state.agents.push(agent)
    },

    UPDATE_TEAM: (state, payload) => {

        state.team = payload
    },

    SET_AGENT_LOADING: (state, agentId) => {
        let selectedAgent = state.agents.find(agent => {
            return agent.id == agentId
        })

        if (selectedAgent) {
            selectedAgent.isLoading = true
        }
    },

    UPDATE_COMMUNITY_AGENTS: (state, payload) => {
        state.communityAgents = payload
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/people.js